import { Star, Quote } from 'lucide-react';
import Card from '../ui/Card';
import { useLanguage } from '../../context/LanguageContext';
import { testimonials, getAverageRating, getTotalReviews } from '../../data/testimonials';

export default function Testimonials() {
  const { t, language } = useLanguage();
  const displayTestimonials = testimonials.slice(0, 3);

  return (
    <section className="py-16 md:py-24 bg-cream-100 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            {t('testimonials.title')}
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
            {t('testimonials.subtitle')}
          </p>

          {/* Rating summary */}
          <div className="flex items-center justify-center gap-4">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-6 h-6 fill-accent-400 text-accent-400"
                />
              ))}
            </div>
            <span className="text-2xl font-bold text-gray-900 dark:text-white">
              {getAverageRating()}
            </span>
            <span className="text-gray-600 dark:text-gray-400">
              ({getTotalReviews()} reviews)
            </span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {displayTestimonials.map((testimonial) => (
            <Card key={testimonial.id} className="relative">
              {/* Quote icon */}
              <div className="absolute -top-3 -left-3 p-2 bg-accent-500 rounded-full">
                <Quote className="w-4 h-4 text-white" />
              </div>

              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-4 h-4 ${
                      i < testimonial.rating
                        ? 'fill-accent-400 text-accent-400'
                        : 'text-gray-300 dark:text-gray-600'
                    }`}
                  />
                ))}
              </div>

              {/* Text */}
              <p className="text-gray-700 dark:text-gray-300 mb-6 italic">
                "{testimonial.text[language]}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-gray-900 dark:text-white">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {testimonial.source}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
